<div class="about-container">
  <section class="hero-section">
    <div class="container">
      <div class="row align-items-center justify-content-center">
        <div class="col-8 text-center" @fadeInUp>
          <h1 class="font-5xl font-bold mb">Chi siamo</h1>
          <div class="divider-line mx-auto"></div>
          <div class="font-base text-muted mb-0 mt-3">
            <span class="font-bold">D.O.P.T</span> è un progetto innovativo di informazione ed educazione finanziaria.<br />
            <span class="font-bold">Parliamo di mercati in modo semplice, chiaro e trasparente.</span><br />
            Aiutiamo le persone a comprendere cosa succede nell'economia e come gestire al meglio i propri risparmi.<br />
            Siamo presenti ogni giorno su <span class="font-bold">Instagram</span> tramite il nostro account <span class="text-primary font-bold">@dopt_finanza</span> e abbiamo la nostra <span class="font-bold">piattaforma digitale</span> completa di contenuti e strumenti utili.
          </div>
        </div>
      </div>
    </div>
  </section>

  <section>
    <div class="container">
      <div class="row g-4 mb-4">
        <div class="col-md-6" [@fadeInDown]>
          <div class="info-card p-4 h-100">
            <h5 class="font-bold mb-2"><i class="fas fa-eye text-primary me-2"></i>Vision</h5>
            <p class="mb-0 text-muted">
              Diventare un punto di riferimento per l’educazione finanziaria in Italia, offrendo <span class="font-bold">strumenti</span> e <span class="font-bold">contenuti</span> di qualità che aiutino le persone a gestire in <span class="font-bold">autonomia</span> le scelte di investimento.
            </p>
          </div>
        </div>
        <div class="col-md-6" [@fadeInDown]="{ value: '', params: { delay: 100 } }">
          <div class="info-card p-4">
            <h5 class="font-bold mb-2"><i class="fas fa-bullseye text-primary me-2"></i>Mission</h5>
            <p class="mb-0 text-muted">
              <span class="font-bold">Educare</span>, <span class="font-bold">informare</span> e <span class="font-bold">semplificare</span> la finanza per tutti con contenuti chiari, strumenti accessibili e linguaggio comprensibile. Accompagniamo l’utente in un percorso evolutivo senza vendere
              prodotti finanziari e senza <span class="font-bold">conflitti di interesse.</span>
            </p>
          </div>
        </div>
      </div>

      <!-- <div class="row g-4 mb-4" [@fadeInDown]="{ value: '', params: { delay: 200 } }">
        <div class="col-12">
          <div class="info-card p-4">
            <h5 class="font-bold mb-2"><i class="fas fa-scale-balanced text-primary me-2"></i>Modello di remunerazione</h5>
            <p class="mb-0 text-muted">
              Nessuna commissione nascosta o provvigione: lavoriamo con una <strong>fee fissa</strong>
              e la massima trasparenza. Il nostro unico interesse è la qualità del servizio
              e l’impatto educativo per la nostra community.
            </p>
          </div>
        </div>
      </div> -->

      <div class="row g-4 mb-4 align-items-stretch">
        <!-- <div class="col-md-5" [@fadeInDown]="{ value: '', params: { delay: 300 } }">
          <div class="info-card p-4 h-100">
            <h5 class="font-bold mb-2"><i class="fas fa-user text-primary me-2"></i>Il fondatore</h5>
            <p class="text-muted mb-1"><strong>Daniele Pinci</strong></p>
            <p class="text-muted mb-0">Appassionato di educazione finanziaria e divulgazione, guida D.O.P.T con l’obiettivo di mettere le persone al centro: autonomia nelle decisioni, chiarezza nei contenuti, responsabilità e indipendenza.</p>
          </div>
        </div> -->
        <div class="col-md-12" [@fadeInDown]="{ value: '', params: { delay: 400 } }">
          <div class="info-card p-4 h-100">
            <h5 class="font-bold mb-2"><i class="fas fa-seedling text-primary me-2"></i>La nostra filosofia</h5>
            <p class="text-muted mb-0">
              Crediamo che la finanza debba essere comprensibile, utile e libera da <span class="font-bold">conflitti di interesse.</span> Per questo costruiamo un percorso progressivo fatto di contenuti chiari, strumenti pratici e supporto continuo. La <span class="font-bold">trasparenza</span> è
              un principio non negoziabile: spieghiamo come lavoriamo, come ci remuneriamo e perché ogni scelta è orientata al <span class="font-bold">bene dell’utente.</span>
            </p>
          </div>
        </div>
      </div>

      <div class="row g-4" [@fadeInDown]="{ value: '', params: { delay: 500 } }">
        <div class="col-12">
          <div class="info-card p-4">
            <h5 class="font-bold mb-2"><i class="fas fa-bullseye text-primary me-2"></i>Cosa facciamo</h5>
            <p class="text-muted">
              <strong>Semplifichiamo la finanza, senza banalizzarla.</strong> Usiamo la tecnologia per rendere tutto accessibile e creiamo strumenti pratici, concreti e indipendenti. <strong>Non vendiamo prodotti finanziari:</strong> il nostro obiettivo è aiutare le persone a capire e scegliere nel
              migliore dei modi, sempre in funzione dei loro interessi personali.
            </p>
            <p class="text-muted">Se non basta, offriamo <strong>servizi di consulenza su misura</strong>, costruiti ad hoc per ogni cliente, perché <strong>seguiamo i vostri interessi, non i nostri</strong>.</p>
            <p class="text-muted">
              Nel mondo dell’informazione finanziaria è facile perdersi tra migliaia di dati, grafici e indicatori che spesso confondono più che chiarire. Con <strong>D.O.P.T</strong> hai accesso a una selezione accurata di charts, statistiche e indicatori rilevanti, dati macroeconomici per leggere
              il ciclo economico e informazioni essenziali sulle grandi aziende che muovono i mercati.
            </p>
            <p class="mb-0 text-muted">Abbiamo un solo obiettivo: <strong>filtrare il rumore e consegnarti solo ciò che vale davvero la pena monitorare</strong>.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<!--<div class="about-container">-->
<!--  <section class="hero-section">-->
<!--    <div class="container">-->
<!--      <div class="row align-items-center min-vh-50">-->
<!--        <div class="col-lg-7">-->
<!--          <h1 class="font-bold font-5xl mb-3">Chi siamo</h1>-->
<!--          <div class="font-base text-muted mb-0">-->
<!--            <span class="font-bold">D.O.P.T</span> è un progetto innovativo di informazione ed educazione finanziaria.<br>-->
<!--            <span class="font-bold">Parliamo di mercati in modo semplice, chiaro e trasparente.</span><br>-->
<!--            Aiutiamo le persone a comprendere cosa succede nell'economia e come gestire al meglio i propri risparmi.<br>-->
<!--            Siamo presenti ogni giorno su <span class="font-bold">Instagram</span> tramite il nostro account <span class="text-primary font-bold">@dopt_finanza</span> e abbiamo la nostra <span class="font-bold">piattaforma digitale</span> completa di contenuti e strumenti utili.-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="col-lg-5 d-none d-lg-block">-->
<!--          <div class="hero-image text-end">-->
<!--            <i class="fas fa-users text-primary" style="font-size: 12rem; opacity: 0.08;"></i>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </section>-->

<!--  <section class="py-5">-->
<!--    <div class="container">-->
<!--      <div class="row g-4 mb-4">-->
<!--        <div class="col-md-6">-->
<!--          <div class="info-card p-4 h-100">-->
<!--            <i class="fas fa-eye text-primary mb-3" style="font-size: 2rem;"></i>-->
<!--            <h5 class="font-bold font-5xl mb-2">Vision</h5>-->
<!--            <p class="mb-0 text-muted">-->
<!--              Diventare un punto di riferimento per l’educazione finanziaria in Italia,-->
<!--              offrendo <span class="font-bold">strumenti</span> e <span class="font-bold">contenuti</span> di qualità che aiutino le persone a gestire-->
<!--              in autonomia le scelte di investimento.-->
<!--            </p>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="col-md-6">-->
<!--          <div class="info-card p-4 h-100">-->
<!--            <i class="fas fa-bullseye text-primary mb-3" style="font-size: 2rem;"></i>-->
<!--            <h5 class="font-bold font-5xl mb-2">Mission</h5>-->
<!--            <p class="mb-0 text-muted">-->
<!--              Educare, informare e semplificare la finanza per tutti con contenuti chiari,-->
<!--              strumenti accessibili e linguaggio comprensibile. Accompagniamo l’utente in-->
<!--              un percorso evolutivo senza vendere prodotti finanziari e senza conflitti di-->
<!--              interesse.-->
<!--            </p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="row g-4 mb-4">-->
<!--        <div class="col-12">-->
<!--          <div class="info-card p-4">-->
<!--            <h5 class="font-bold mb-2"><i class="fas fa-scale-balanced text-primary me-2"></i>Modello di remunerazione</h5>-->
<!--            <p class="mb-0 text-muted">-->
<!--              Nessuna commissione nascosta o provvigione: lavoriamo con una <strong>fee fissa</strong>-->
<!--              e la massima trasparenza. Il nostro unico interesse è la qualità del servizio-->
<!--              e l’impatto educativo per la nostra community.-->
<!--            </p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="row g-4 mb-4 align-items-stretch">-->
<!--        <div class="col-md-5">-->
<!--          <div class="info-card p-4 h-100">-->
<!--            <h5 class="font-bold mb-2"><i class="fas fa-user text-primary me-2"></i>Il fondatore</h5>-->
<!--            <p class="text-muted mb-1"><strong>Daniele Pinci</strong></p>-->
<!--            <p class="text-muted mb-0">-->
<!--              Appassionato di educazione finanziaria e divulgazione, guida D.O.P.T con l’obiettivo-->
<!--              di mettere le persone al centro: autonomia nelle decisioni, chiarezza nei contenuti,-->
<!--              responsabilità e indipendenza.-->
<!--            </p>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="col-md-7">-->
<!--          <div class="info-card p-4 h-100">-->
<!--            <h5 class="font-bold mb-2"><i class="fas fa-seedling text-primary me-2"></i>La nostra filosofia</h5>-->
<!--            <p class="text-muted mb-0">-->
<!--              Crediamo che la finanza debba essere comprensibile, utile e libera da conflitti di interesse.-->
<!--              Per questo costruiamo un percorso progressivo fatto di contenuti chiari, strumenti pratici e-->
<!--              supporto continuo. La trasparenza è un principio non negoziabile: spieghiamo come lavoriamo,-->
<!--              come ci remuneriamo e perché ogni scelta è orientata al bene dell’utente.-->
<!--            </p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="row g-4 mb-4">-->
<!--        <div class="col-12">-->
<!--          <div class="info-card p-4">-->
<!--            <h5 class="font-bold mb-2"><i class="fas fa-bullseye text-primary me-2"></i>Cosa facciamo</h5>-->
<!--            <p class=" text-muted">-->
<!--              <strong>Semplifichiamo la finanza, senza banalizzarla.</strong> Usiamo la tecnologia per rendere tutto accessibile e creiamo strumenti pratici, concreti e indipendenti. <strong>Non vendiamo prodotti finanziari:</strong> il nostro obiettivo è aiutare le persone a capire e scegliere nel migliore dei modi, sempre in funzione dei loro interessi personali.-->
<!--            </p>-->
<!--            <p class=" text-muted">-->
<!--              Se non basta, offriamo <strong>servizi di consulenza su misura</strong>, costruiti ad hoc per ogni cliente, perché <strong>seguiamo i vostri interessi, non i nostri</strong>.-->
<!--            </p>-->
<!--            <p class=" text-muted">-->
<!--              Nel mondo dell’informazione finanziaria è facile perdersi tra migliaia di dati, grafici e indicatori che spesso confondono più che chiarire. Con <strong>D.O.P.T</strong> hai accesso a una selezione accurata di charts, statistiche e indicatori rilevanti, dati macroeconomici per leggere il ciclo economico e informazioni essenziali sulle grandi aziende che muovono i mercati.-->
<!--            </p>-->
<!--            <p class="mb-0 text-muted">-->
<!--              Abbiamo un solo obiettivo: <strong>filtrare il rumore e consegnarti solo ciò che vale davvero la pena monitorare</strong>.-->
<!--            </p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </section>-->
<!--</div>-->
